import { Sparkles } from "lucide-react";
import { Button } from "@/design-system/components/ui/button";
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
  DrawerTitle,
  DrawerHeader,
} from "@/design-system/components/ui/drawer"; // O tu librería de Sheets/Drawers
import { PublicClinicAIWidget } from "./PublicClinicAIWidget";
import { useTranslation } from "react-i18next";

export function MobileAIWidgetDrawer({ clinicId }: { clinicId: string }) {
  const { t } = useTranslation(["landing"]);
  
  return (
    <Drawer>
      {/* Botón Flotante Fijo (FAB) */}
      <DrawerTrigger asChild>
        <Button
          size="lg"
          className="fixed bottom-6 right-6 z-50 rounded-full h-14 px-5 shadow-xl bg-primary text-primary-foreground font-bold text-xs uppercase tracking-wider gap-2 border border-primary-foreground/20 animate-bounce-slow"
        >
          <Sparkles size={16} fill="currentColor" />
          <span>{t("landing:ai.fab")}</span>
        </Button>
      </DrawerTrigger>

      {/* Contenido que desliza desde abajo */}
      <DrawerContent className="max-h-[85vh] p-4 bg-card border-t border-border rounded-t-[32px]">
        {/* Título invisible para accesibilidad/screen readers */}
        <DrawerHeader className="sr-only">
          <DrawerTitle>{t("landing:ai.drawer_title")}</DrawerTitle>
        </DrawerHeader>

        {/* Renderizamos el mismo widget exacto dentro del menú deslizable */}
        <div className="overflow-y-auto pb-8 pr-1">
          <PublicClinicAIWidget clinicId={clinicId} />
        </div>
      </DrawerContent>
    </Drawer>
  );
}
